import { Component, OnInit, OnDestroy, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormModalService, FormModalState } from 'src/app/Services/Forms/form-modal.service';
import { Form_Template_With_Fields } from 'src/app/Interfaces/Forms/FormTemplate.interface';
import { FormFillCDMSComponent } from '../form-fill-cdms/form-fill-cdms.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-form-modal-cdms',
  templateUrl: './form-modal-cdms.component.html',
  styleUrls: ['./form-modal-cdms.component.scss'],
  standalone: false
})
export class FormModalCDMSComponent implements OnInit, OnDestroy {

  private modalService = inject(FormModalService);
  private cdr = inject(ChangeDetectorRef);
  private sub!: Subscription;

  public IsOpen: boolean = false;
  public Template: Form_Template_With_Fields | null = null;
  public PreloadValues: { [fieldId: number]: string | null } = {};
  public FormValues: { ID_Field: number, Value: string | null }[] = [];
  public FormFiles: { ID_Field: number, File: File }[] = [];

  @ViewChild(FormFillCDMSComponent) formFillComponent!: FormFillCDMSComponent;

  ngOnInit(): void {
    console.log('[FormModal] ngOnInit - subscribing to service');
    this.sub = this.modalService.state$.subscribe((state: FormModalState) => {
      console.log('[FormModal] state received:', state.isOpen, state.template?.Name);
      this.IsOpen = state.isOpen;
      this.Template = state.template;
      this.PreloadValues = state.preloadValues;
      if (!state.isOpen) {
        this.FormValues = [];
        this.FormFiles = [];
      }
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  public OnValuesChange(values: { ID_Field: number, Value: string | null }[]): void {
    this.FormValues = values;
  }

  public OnFilesChange(files: { ID_Field: number, File: File }[]): void {
    this.FormFiles = files;
  }

  public Confirm(): void {
    if (this.formFillComponent && !this.formFillComponent.isValid()) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Formulario incompleto',
        text: 'Complete los campos obligatorios antes de confirmar.',
        confirmButtonColor: '#20a8e1',
        didOpen: () => {
          (Swal.getContainer() as HTMLElement).style.zIndex = '3000';
        }
      });
      return;
    }
    this.modalService.confirm(this.FormValues, this.FormFiles);
  }

  public Cancel(): void {
    this.modalService.cancel();
  }

  public GetFilledCount(): number {
    return this.FormValues.filter(v => v.Value !== null && v.Value !== '').length;
  }

  public GetTotalCount(): number {
    if (!this.Template) return 0;
    return this.Template.Fields.filter(f => f.Field_Type !== 'section').length;
  }
}
